// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"334":"625d698d","351":"376484cc","453":"9a483010"}[chunkId] + ".chunk.js";
};